import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../stateless/SnackBarProvider';
import { useResendOTPApi } from '../../Hooks/useResendOTPApi';

export const useResendOTP = () => {
  const { showMessage } = useSnackbar();
  const { createResendOTP } = useResendOTPApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createResendOTP(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Password successfully reset',
        'success'
      );
    },
    onError: (error: any) => {
      showMessage(error.response?.data?.message || 'Failed to login', 'error');
    },
  });
};
